import { render, staticRenderFns } from "./ModalSupervisorCollaborator.vue?vue&type=template&id=7e757b53&"
import script from "./ModalSupervisorCollaborator.vue?vue&type=script&lang=js&"
export * from "./ModalSupervisorCollaborator.vue?vue&type=script&lang=js&"
import style0 from "./ModalSupervisorCollaborator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports